import { QueryKey, useQuery } from "@tanstack/react-query";
import { TableDataRes } from "components/table/base/tableBaseApi";
import { MRT_ColumnFiltersState, MRT_SortingState } from "material-react-table";
import { StoreContext } from "models/import";
import { ValidationTableDef, ValidationDetail } from "models/validation";
import { useContext } from "react";
import { serializeTaxReportBody, getTaxReportsApiData } from "services/api";
import { getDateString, getTimestamp } from 'services/transactions';

const mapToSortId = (sortId: string): number | string => {
  switch (sortId) {
    case 'transaction_time':
      return 0;
    case 'transaction_type':
      return 1;
    case 'exchange':
      return 2;
    case 'trade_group':
      return 3;
    case 'trade_id':
      return 4;
    case 'trade_hash':
      return 4;
    case 'transaction_id':
      return 4;
    case 'imported_from':
      return 5;
    // case 'transaction_value_in_fiat':
    //   return 6;
    // case 'coin':
    //   return 6;
    default:
      return sortId;
  }
};

export function useGetValidationRequest(
    tableName: string,
    url: string,
    setIsFetching: (value: boolean) => void,
    columnFilters: MRT_ColumnFiltersState,
    globalSearch: string | null,
    pageIndex: number,
    pageSize: number,
    sorting: MRT_SortingState,
    filters: string,
    onLoad: (value: TableDataRes<ValidationTableDef, ValidationDetail> | null) => void,
    enabled: boolean = true,
) {
    const { userSettings } = useContext(StoreContext);

    return useQuery<TableDataRes<ValidationTableDef, ValidationDetail> | null>({
      queryKey: [
        tableName,
        columnFilters, 
        globalSearch, 
        pageIndex, 
        pageSize, 
        sorting, 
        filters,
        userSettings?.userId,
      ],
      queryFn: async () => {
        if (filters === '' || filters === '{}') { return null; }
        setIsFetching(true);
        const sortWithIdMapping = sorting.map((sort) => ({ id: mapToSortId(sort.id), desc: sort.desc }));
        const jsonRequest = {
          user_id: userSettings?.userId,
          page: pageIndex,
          limit: pageSize,
          global_filter: globalSearch,
          sort_direction: sortWithIdMapping ?? [],
        };
  
        const filter: any = {};

        for (const singleFilter of columnFilters) {
          if (singleFilter.id === 'transaction_time' && singleFilter.value) { // workaround only for date
            if (typeof singleFilter.value === 'string'
            && !Array.isArray(singleFilter.value)) { // single value - only checking for object would still return true
              filter.transaction_time = getTimestamp(singleFilter.value);
            } else if (Array.isArray(singleFilter.value)
            && singleFilter.value.length === 2) { // value between
              filter.transaction_time_from = getTimestamp(singleFilter.value[0]);
              filter.transaction_time_to = getTimestamp(singleFilter.value[1]);
            } else { // do not set date in case of error
              console.log('date error ' + singleFilter.value);
            }
          } else { // not date -> default behaviour
            filter[singleFilter.id] = singleFilter.value;
          }
        }
  
        const filterJson: any = JSON.parse(filters);
        const mergedObject: any = {
          ...jsonRequest,
          ...filterJson,
          ...filter,
        };
        const queryString: string = serializeTaxReportBody({
          method: 'GET',
          path: url,
          body: JSON.stringify(mergedObject),
          header: 'Accept: application/json',
        });
  
        const response = await getTaxReportsApiData<
        TableDataRes<ValidationTableDef, ValidationDetail>
        >(
          `?${queryString}`,
        );
        setIsFetching(false);
        onLoad(response);
        return response;
      },
      enabled: enabled,
    });
}